import styled from 'styled-components'
import { COLORS } from '@styles/colors'
import { FONTS } from '@styles/fonts'
import { DEVICES } from '@constants/global'

export const SearchResultCount = styled.div`
  display: flex;
  align-items: center;
  font-size: 18px;
  line-height: 26px;
  margin-bottom: 24px;
  color: ${COLORS.secondary};
  font-family: ${FONTS.medium};

  span:first-child {
    font-family: ${FONTS.regular};
  }

  @media ${DEVICES.mobile} {
    display: block;
  }
`

export const SearchResultCountActions = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-left: auto;

  .bp-checkbox-label {
    display: flex;
    align-items: center;
    gap: 8px;
    font-family: ${FONTS.medium};
    line-height: 1.2;
    margin-right: auto;
    font-size: 16px;
  }

  > div {
    display: none;
  }

  @media ${DEVICES.mobile} {
    flex: 1;
    justify-content: space-between;
    margin-left: 0;
    margin-top: 16px;

    > div {
      display: block;
    }

    .main-select-container .react-select__control {
      border-color: ${COLORS.secondary};
      min-height: unset;
    }
    .main-select-container .react-select__input-container {
      margin: 0 2px;
    }
  }
`
